import { useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getJourneys } from '../../services/journeyService';
import { apiParamsState } from '../../storage/app';
import {
  filterStatusState,
  journeysState,
  loadingJourneysState,
  orderDirectionState,
  searchJourneyState,
  sortJourneysState,
  updateJourneysState,
} from '../../storage/journeys';

export function JourneysProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const updateJourneys = useRecoilValue(updateJourneysState);
  const resetUpdateJourneys = useResetRecoilState(updateJourneysState);
  const setJourneys = useSetRecoilState(journeysState);
  const setLoadingJourneys = useSetRecoilState(loadingJourneysState);
  const order = useRecoilValue(orderDirectionState);
  const orderBy = useRecoilValue(sortJourneysState);
  const search = useRecoilValue(searchJourneyState);
  const status = useRecoilValue(filterStatusState);

  const loadJourneys = async () => {
    const invalid = !apiParams?.clientId || !apiParams.subClientId;
    if (invalid) return;

    const { journeys, error } = await getJourneys({
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      order,
      orderBy,
      search,
      status,
    });
    if (!error && journeys) {
      setJourneys(journeys);
    } else {
      setJourneys(undefined);
    }
  };

  useEffect(() => {
    setLoadingJourneys(true);
    loadJourneys().finally(() => {
      setLoadingJourneys(false);
    });
  }, [apiParams?.clientId, apiParams?.subClientId]);

  useUpdateEffect(() => {
    if (!updateJourneys) return;

    loadJourneys().finally(() => {
      resetUpdateJourneys();
    });
  }, [updateJourneys]);

  useUpdateEffect(() => {
    loadJourneys();
  }, [search, orderBy, order, status]);

  return null;
}
